import React from 'react';
import {useContextSelector} from 'use-context-selector';
import {Helmet} from 'react-helmet';
import {LinkContainer} from 'react-router-bootstrap';
import {Card, ListGroup} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import LayoutContentContainer from '../common/LayoutContentContainer';

import Layout from '../common/Layout';
import {LocalContext} from '../context/LocalContext';

const SitemapLink = (props) => {
    return <LinkContainer
        to={props.to}
        exact={true}
        style={
            {
                fontFamily: 'Ubuntu, sans-serif'
            }
        }
    >
        <ListGroup.Item action className="rounded-0">{props.title}</ListGroup.Item>
    </LinkContainer>
}

const Sitemap = () => {
    const {t} = useTranslation();
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);
    const UIRoles = useContextSelector(LocalContext, v => v[0].user.data.UIRoles);

    return <Layout navSecondaryShow={true} className="bg-light" contentBackgroundArt={true}>
        <Helmet><title>{t('Sitemap.page-head-title')}</title></Helmet>

        <LayoutContentContainer
            style={
                {
                    maxWidth: '50rem'
                }
            }
        >
            <h1
                style={
                    {
                        fontWeight: 400
                    }
                }
            >{t('Sitemap.sitemap')}</h1>
            <Card
                style={
                    {
                        overflow: `hidden`,
                    }
                }
            >
                {/* <Card.Header>Competence Map</Card.Header> */}
                <ListGroup
                    variant="flush"
                >
                    <SitemapLink to="/" title={t('Links.home')} />
                    <SitemapLink to="/providers-search" title={t('Links.find-providers')} />
                    <SitemapLink to="/provider-application" title={t('Links.provider-application')} />
                    <SitemapLink to="/provider-acceptance-terms" title={t('Links.provider-acceptance-terms')} />
                    {
                        userAuthenticated ?
                            <>
                                <SitemapLink to="/dashboard" title={t('Links.dashboard.dashboard')} />
                                <ListGroup.Item
                                    className="py-0 pr-0 bg-light"
                                >
                                    <Card
                                        className="border-top-0 border-bottom-0 border-right-0 rounded-0"
                                    >
                                        <ListGroup
                                            variant="flush"
                                        >
                                            {UIRoles.DIH ?
                                                <SitemapLink to="/dashboard/dih-management" title={t('Links.dashboard.dih-management')} /> : null}
                                            {UIRoles.SA ?
                                                <SitemapLink to="/dashboard/system-administration" title={t('Links.dashboard.system-administration')} /> : null}
                                        </ListGroup>
                                    </Card>
                                </ListGroup.Item>
                            </> :
                            null
                    }
                    <SitemapLink to="/cookies-policy" title={t('Links.cookies-policy')} />
                    <SitemapLink to="/privacy-policy" title={t('Links.privacy-policy')} />
                    <SitemapLink to="/contact-us" title={t('Links.contact-us')} />
                </ListGroup>
            </Card>
        </LayoutContentContainer>
    </Layout>
}

export default Sitemap;
